export default {
  isMarkAsPaidModalShown: (state) => state.isShown,
  isInvoiceAmount: (state) => state.formData.amount,
  isInvoiceId: (state) => state.invoiceId,
  isSaving: (state) => state.saving,
  isSuccess: (state) => state.success,
  isErrors: (state) => state.errors,
};
